import React, { PureComponent } from "react";
import VerbodenTimer from "../../../components/verbodenTimer";
import VerbodenGameLayout from "../../../components/verbodenGameLayout";
import Guessing from "./guessing";
import GBS from "./gbs";
import GBSSelected from "./gbsSelected";
import { connect } from "react-redux";
import { withSocket } from "../../../socket/context";
import { compose } from "redux";
import { withRouter } from "react-router-dom";
import * as loaderAction from "../../../redux/loader/action";
import * as game3Action from "../../../redux/game3/actions";
import { Redirect } from "react-router-dom";
import _ from "lodash";
import { AnimatePresence } from "framer-motion";

class GamePlay extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      quarterback: "",
      currentTeam: "",
      audioUrl: {},
    };
  }

  componentDidMount() {
    let roomData = this.props.gameReducer.roomObj;
    if (
      roomData &&
      roomData.game_state &&
      roomData.game_state.status &&
      roomData.game_state.status === "Joining"
    ) {
      this.props.setIsLoading(true);
    }
  }

  static setCurrentTeam_quaterBack = (props) => {
    let currentTeam = " A";
    let teams = "";
    let roomData = props.gameReducer.roomObj;
    let team1QuaterBack = {};
    let team2QuaterBack = {};
    const roomUsers = roomData.users;
    if (roomData.game_state && roomData.game_state.current_team) {
      currentTeam = roomData.game_state.current_team;
    }
    if (
      roomData &&
      roomData.game_state &&
      roomData.game_state.teams &&
      roomData.game_state.teams.length > 0
    ) {
      teams = roomData.game_state.teams;
      if (teams[0]) {
        team1QuaterBack = roomUsers.find(
          (user) => user.player_id === teams[0].quarterback
        );
      }
      if (teams[1]) {
        team2QuaterBack = roomUsers.find(
          (user) => user.player_id === teams[1].quarterback
        );
      }
    }
    let data = {
      currentTeam: currentTeam,
      teamAquaterBack: team1QuaterBack,
      teamBquaterBack: team2QuaterBack,
    };
    props.setCurrentTeam(data);
  };

  static getDerivedStateFromProps(nextProps, state) {
    let roomObj = nextProps.gameReducer.roomObj;
    let { gameObj } = nextProps.paramsReducer;

    if (Object.keys(gameObj).length > 0) {
      if (
        Object.keys(roomObj).length > 0 &&
        nextProps.loaderDetails.isLoading &&
        roomObj.game_state.status === "PreGuess"
      ) {
        nextProps.setIsLoading(false);
        GamePlay.setCurrentTeam_quaterBack(nextProps);
      }
    }
  }
  playAudio = (url) => {
    var audio = document.createElement("audio");
    audio.src = url;
    audio.style.display = "none";
    audio.autoplay = true;
    audio.onended = function () {
      audio.remove();
    };
    document.body.appendChild(audio);
  };
  componentDidUpdate(prevProps) {
    let roomData = this.props.gameReducer.roomObj;
    let prevRoom = prevProps.gameReducer.roomObj;
    let team1Data = {};
    let team2Data = {};
    let teams = {};
    let currentTeam = "";
    let prevCurrentTeam = "";
    let currentTeamQuaterBack = "";
    const { buzzInfo } = this.props.game3Reducer;
    const { paramsReducer } = this.props;
    const buzzerTrack = _.get(paramsReducer, "gameObj.tabletop_buzzer_sound");
    if (
      buzzInfo &&
      roomData &&
      roomData.tabletop &&
      roomData.game_code === "VB"
    ) {
      this.setState({ audioUrl: buzzerTrack });
    }
    if (!!buzzInfo) {
      setTimeout(async () => {
        await this.props.setBuzzInfo({ buzzInfo: null });
      }, 1200);
    }

    const roomUsers = roomData.users;
    if (roomData.game_state && roomData.game_state.current_team) {
      currentTeam = roomData.game_state.current_team;
    }
    if (
      prevRoom &&
      prevRoom?.game_state &&
      roomData?.game_state?.current_team
    ) {
      prevCurrentTeam = prevRoom?.game_state?.current_team;
    }
    if (currentTeam !== prevCurrentTeam) {
      this.setState({
        currentTeam: currentTeam,
        quarterback: "",
      });
    }

    if (
      roomData &&
      roomData.game_state &&
      roomData.game_state.teams &&
      roomData.game_state.teams.length > 0
    ) {
      teams = roomData.game_state.teams;
      if (teams[0]) {
        team1Data = teams[0];
      }
      if (teams[1]) {
        team2Data = teams[1];
      }
    }
    let team = team1Data;
    if (currentTeam !== "A") {
      team = team2Data;
    }
    if (team && team.quarterback) {
      currentTeamQuaterBack = roomUsers.find(
        (user) => user.player_id === team.quarterback
      );

      if (this.state.quarterback === "") {
        this.setState({
          quarterback: currentTeamQuaterBack,
        });
      }
    }
  }

  render() {
    const { quarterback } = this.state;
    const { timer, buzzInfo } = this.props.game3Reducer;
    let statusOfGame = "Joining";
    let roomData = this.props.gameReducer.roomObj;

    if (roomData && roomData.game_state && roomData.game_state.status) {
      statusOfGame = roomData.game_state.status;
    }
    if (statusOfGame === "ResultRound") {
      return <Redirect to={"/verboden/result"} />;
    }
    if (statusOfGame === "Over") {
      return <Redirect to={"/verboden/final"} />;
    }
    const gameObj = this.props.paramsReducer.gameObj;

    return (
      <VerbodenGameLayout
        users={roomData.users}
        gameReducer={this.props.gameReducer}
      >
        <div key="vb_2" className="verboden-game-play">
          {/* <div className="verboden-game-timer buzzed"> */}
          <div className={`verboden-game-timer ${buzzInfo ? "buzzed" : ""}`}>
            <VerbodenTimer timer={timer} buzzInfo={buzzInfo} />

            <AnimatePresence exitBeforeEnter>
              {statusOfGame === "PreGuess" ? (
                <Guessing
                  key="vb_guessing"
                  roomData={roomData}
                  gameObj={gameObj}
                />
              ) : (
                <>
                  {!buzzInfo && <GBS />}
                  {buzzInfo && <GBSSelected buzzInfo={buzzInfo} />}
                </>
              )}
            </AnimatePresence>
          </div>
        </div>
      </VerbodenGameLayout>
    );
  }
}

const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  game3Reducer: state.game3Reducer,
  paramsReducer: state.paramsReducer,
  loaderDetails: state.loaderDetails,
});

const mapDispatchToProps = (dispatch) => {
  return {
    setCurrentTeam: (data) => dispatch(game3Action.setCurrentTeam(data)),
    setBuzzInfo: (data) => dispatch(game3Action.setBuzzInfo(data)),
    setIsLoading: (data) => dispatch(loaderAction.setIsLoading(data)),
  };
};

export default compose(
  withRouter,
  withSocket,
  connect(mapStateToProps, mapDispatchToProps)
)(GamePlay);
